export default "__VITE_ASSET__DdPHPVFD__"